import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PackageIcon } from 'lucide-react';
export function BulkItemPickup() {
  return <div className="w-full min-h-screen bg-white" data-id="element-234">
      <Header data-id="element-235" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-236">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8qh7w8bd7QtYdXVnf41h1b/BulkItemPickup.png" alt="Bulk Item Pickup" className="w-full h-full object-cover" data-id="element-237" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-238"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-239">
          <div className="text-center" data-id="element-240">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-241">
              <PackageIcon className="w-10 h-10 text-[#E41C1C]" data-id="element-242" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-243">Bulk Item Pickup</h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-244">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
          <div className="space-y-6" data-id="element-246">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-247">
              Sometimes you need to dispose of items that are too large for your
              regular trash pickup—old furniture, appliances, mattresses, or
              other oversized items that don't fit in standard containers. Our
              bulk item pickup service provides a convenient, on-demand solution
              for removing these larger items from your property without the
              hassle of renting a truck or making multiple trips to the
              landfill.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-248">
              Simply give us a call when you have bulk items ready for removal,
              and we'll schedule a pickup at your convenience. Our experienced
              team handles the heavy lifting and ensures that items are disposed
              of responsibly. Whether you're decluttering your home, upgrading
              appliances, or clearing out a storage space, we make the process
              easy and stress-free.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-249">
              This service is ideal for spring cleaning, moving, downsizing, or
              any time you need to get rid of large items quickly. With
              transparent pricing and reliable service, Sam's Disposal takes the
              burden off your shoulders so you can focus on more important
              things. We're committed to keeping our community clean and helping
              residents manage waste of all sizes.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-250">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-251">
              Schedule a Bulk Item Pickup
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-252">
              Call us to arrange pickup of your large items at a time that works
              for you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-253">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-254">
                Call (231) 796-2952
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-255" />
    </div>;
}